import { makeStyles, Typography, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useRecentCallback } from './utils';
import { useSnackbarInstance } from './use-snackbar-instance';

const useStyle = makeStyles({
  hideIcon: {
    '& #notistack-snackbar > svg': {
      display: 'none',
    },
  },
});

export function useFormSnackbarError() {
  const sstyle = useStyle();
  const { enqueue, close } = useSnackbarInstance();
  const [formError] = useRecentCallback(err => {
    enqueue(
      <div>
        <Typography>Please correct the following errors</Typography>
        <ul style={{ paddingLeft: '10px' }}>
          {Object.entries(err).map(([key, { message }]: [string, any]) => (
            <li key={key}>{message}</li>
          ))}
        </ul>
      </div>,
      {
        action: () => (
          <IconButton onClick={close}>
            <Close style={{ color: 'white' }} />
          </IconButton>
        ),
        className: sstyle.hideIcon,
        variant: 'error',
        // autoHideDuration: 5000,
        persist: true,
      }
    );
  });

  return formError;
}
